import axios from 'axios';
import {fileConfig} from "./config";
import {
  reToken,
} from "@/services/login";
import {Loading, Message} from 'element-ui'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import Vue from "vue";


let refreshToken = 0 // 换token只请求一次标识
let TokenInvalidFlag = 0;//token 失效只提示一次
let resIng = false;//存在正在请求中的接口不刷新token
//1、创建axios 实例
//fileConfig
const service = axios.create();

// todo 添加一个请求拦截器，用于设置请求过渡状态
service.interceptors.request.use((config) => {
  // 请求开始，蓝色过渡滚动条开始出现
  //注册获取验证码不需要cookie
  config.headers['Authorization'] = Vue.$cookies.get('token');
  let reg = config.url.indexOf('/admin/login/register') !== -1 || config.url.indexOf('/admin/app/app') !== -1 || config.url.indexOf('/admin/user/password') !== -1;
  if (!reg && !Vue.$cookies.get('token') && TokenInvalidFlag == 0) {
    Message.warning('登录信息失效，请重新登录!')
    setTimeout(() => {
      window.location.replace('/');
      Vue.ls.clear()
    }, 500);
    TokenInvalidFlag = 1;
  }


  //todo 刷新token的条件为剩余时间小于15分钟时刷新一次（在操作的情况下）
  if (Vue.$cookies.get('token') && Vue.$cookies.get('tokenTime') - (+new Date()) < 10 * 60 * 1000 && refreshToken !== 1 && !resIng) {
    refreshToken = 1;
    reToken({
      access_token: Vue.$cookies.get('access_token'),
      refresh_token: Vue.$cookies.get('re_token'),
      grant_type: 'refresh_token'
    }).then((res) => {
      if (res.code === 0) {
        refreshToken = 0;
        //设置cookie 30分钟失效
        let time = +new Date() + res.data.expires_in * 1000;//半个小时后的时间戳
        Vue.$cookies.set('tokenTime', time);
        Vue.$cookies.set('token', 'Bearer' + ' ' + res.data.access_token, `${res.data.expires_in / 60}min`);
        Vue.$cookies.set('re_token', res.data.refresh_token, `${res.data.expires_in / 60}min`);
        Vue.$cookies.set('access_token', res.data.access_token, `${res.data.expires_in / 60}min`);
      }
    })
  }

  NProgress.start();
  resIng = true;
  return config;
}, (error) => {
  return Promise.reject(error);
});

// todo 添加一个返回拦截器
service.interceptors.response.use((response) => {
  NProgress.done();
  resIng = false;
  return response;
}, (error) => {
  // 请求结束，蓝色过渡滚动条消失
  // 即使出现异常，也要调用关闭方法，否则一直处于加载状态很奇怪
  NProgress.done();
  return Promise.reject(error);
});

const fileRequest = (url, params, options = {loading: true, mock: false, error: true}) => {
  let loadingInstance;
  // 请求前loading
  if (params.loading) loadingInstance = Loading.service({text: '正在上传，请勿关闭！'});
  return new Promise((resolve, reject) => {
    let data = {}
    // get请求使用params字段
    if (params.method == 'get') data = {params: params.data};
    // post请求使用data字段
    if (params.method == 'post') data = {data: params.data};
    // let a = qs.stringify(params.data);
    service({url, method: params.method, data: params.data,}).then((res) => {
      if (res.status === 200) {
        resolve(res.data);
        // resolve({code: 0, msg: null, data: res.data});
      }
      if (params.promptMessage) {
        Message.success(params.promptMessage);
      }
    }).catch((error) => {
      //todo 处理错误(可以获取到error.response和error.message)
      if (error.response && error.response.status == 424 && TokenInvalidFlag == 0) {
        //token失效
        Message.warning('登录已失效，请重新登录！');
        setTimeout(() => {
          window.location.replace('/');
          Vue.ls.clear()
        }, 500);
        TokenInvalidFlag = 1;
      } else if (error.response && error.response.status == 426) {
        //用户名密码错误
        if (error && error.response && error.response.data) {
          Message.error(error.response.data.msg);
        }
      } else if (error.response && error.response.status != 424 && error.response && error.response.status != 426) {
        if (error && error.response && error.response.data) {
          Message.error(error.response.data.msg);
        }
      }
    }).finally(() => {
      //关闭加载
      loadingInstance.close();
    })
  })
};

export default fileRequest



// WEBPACK FOOTER //
// ./src/utils/fileRequest.js